export const scrollTo = (ref) => {
    setTimeout(() => {
        ref.current.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
};